var map = {
	"./0.jpeg": "4fc0",
	"./1.jpeg": "1b6d",
	"./2.jpeg": "784d",
	"./3.jpeg": "7738",
	"./4.jpeg": "2e16",
	"./5.jpeg": "e151",
	"./6.jpeg": "62a7",
	"./7.jpeg": "c145",
	"./8.jpeg": "a514"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c7e6";